import React from 'react';

/**
 * Tiny "🔒 Available in higher plan" marker shown beneath a feature toggle
 * when the active workspace template disallows it. Stays purely
 * presentational — keeps the editor file free of inline JSX for a recurring
 * concept.
 */
const LockOverlay = ({ label = 'Available in higher plan' }) => (
  <div
    data-testid="feature-lock-overlay"
    style={{
      marginTop: '8px',
      padding: '6px 10px',
      fontSize: '11px',
      color: 'var(--kahla-text-light)',
      background: 'var(--kahla-cream-light)',
      border: '1px dashed var(--kahla-border)',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      lineHeight: 1.5,
    }}
  >
    <span aria-hidden>🔒</span>
    <span>{label}</span>
  </div>
);

export default LockOverlay;
